module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/hyper_3x.6408869.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/hyper_3x.png
// module id = ha7Y
// module chunks = 41